import { Metric } from "~/api/contracts/models";

export function useMetricCategory(metric: Metric) {
  switch (metric) {
    case Metric.TTFB:
    case Metric.TTFBFromChina:
    case Metric.TTFBNearOrigin:
    case Metric.GlobalNetworkOverhead:
    case Metric.GlobalDNSResolveTime:
    case Metric.GooglebotTTFB:
    case Metric.CoreWebVitals:
      return "Performance";
    case Metric.WAFBlock:
    case Metric.WAFOwaspBlock:
    case Metric.WAFRequestsBlocked:
      return "Security";
    case Metric.ThirtyDaysAvailabilityForApplication:
    case Metric.ThirtyDaysAvailabilityForInfrastructure:
      return "Availability";
    default:
      return "";
  }
}
